// src/component/sharedComponents/Loader.jsx
export default function Loader() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div className="w-16 h-16 border-4 border-gray-300 rounded-full border-t-custom-move animate-spin"></div>
    </div>
  );
}
